import { render } from "./ExportContabilita.vue?vue&type=template&id=6e48c70b&scoped=true"
import script from "./ExportContabilita.vue?vue&type=script&lang=js"
export * from "./ExportContabilita.vue?vue&type=script&lang=js"

import "./ExportContabilita.vue?vue&type=style&index=0&id=6e48c70b&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e48c70b"]])

export default __exports__